<script>
import { Line } from 'vue-chartjs'

// const brandInfo = '#63c2de'

export default {
  extends: Line,
  props: ['data', 'labels', 'height'],
  methods: {
    montarGrafico () {
      this.renderChart({
        labels: this.labels,
        datasets: this.data
      }, {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              color: 'transparent',
              zeroLineColor: 'transparent'
            },
            ticks: {
              fontSize: 2,
              fontColor: 'transparent'
            }
          }],
          yAxes: [{
            display: false,
            ticks: {
              display: false,
              min: Math.min.apply(Math, this.data[0].data) - 5,
              max: Math.max.apply(Math, this.data[0].data) + 5
            }
          }]
        },
        elements: {
          line: {
            borderWidth: 1
          },
          point: {
            radius: 4,
            hitRadius: 10,
            hoverRadius: 4
          }
        }
      })
    }
  },
  watch: {
    labels: function () {
      this.montarGrafico()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/CardLine2ChartExample.vue